// Whether the app sidebar starts open (Drew, 2026-11-04: "When the window is narrower than
// about 1500px, start the sidebar collapsed, so the section gets the extra width. Users can
// still open it."). Once someone opens or closes it, that choice holds for the rest of the
// tab, so moving to another page never snaps it back.

export const SIDEBAR_COLLAPSE_BELOW = 1500;

let chosen: boolean | null = null;

export function sidebarStartsOpen(windowWidth: number = typeof window === "undefined" ? SIDEBAR_COLLAPSE_BELOW : window.innerWidth): boolean {
  return chosen ?? windowWidth >= SIDEBAR_COLLAPSE_BELOW;
}

export function rememberSidebarChoice(open: boolean): void {
  chosen = open;
}

/** Tests only: forget the tab's choice. */
export function resetSidebarChoice(): void {
  chosen = null;
}
